import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchCampaign = createAction(constants.FETCH_CAMPAIGN)
export const fetchCampaignPending = createAction(constants.FETCH_CAMPAIGN_PENDING)
export const fetchCampaignCancelled = createAction(constants.FETCH_CAMPAIGN_CANCELLED)
export const fetchCampaignFailed = createAction(constants.FETCH_CAMPAIGN_FAILED)

export const updateCampaign = createAction(constants.UPDATE_CAMPAIGN)
export const updateCampaignPending = createAction(constants.UPDATE_CAMPAIGN_PENDING)
export const updateCampaignCancelled = createAction(constants.UPDATE_CAMPAIGN_CANCELLED)
export const updateCampaignFailed = createAction(constants.UPDATE_CAMPAIGN_FAILED)

export const receiveCampaign = createAction(constants.RECEIVE_CAMPAIGN)

export const searchCampaigns = createAction(constants.SEARCH_CAMPAIGNS)
export const searchCampaignsPending = createAction(constants.SEARCH_CAMPAIGNS_PENDING)
export const searchCampaignsCancelled = createAction(constants.SEARCH_CAMPAIGNS_CANCELLED)
export const searchCampaignsFailed = createAction(constants.SEARCH_CAMPAIGNS_FAILED)
export const searchCampaignsSuccess = createAction(constants.SEARCH_CAMPAIGNS_SUCCESS)

export const loadMoreCampaigns = createAction(constants.LOAD_MORE_CAMPAIGNS)
export const loadMoreCampaignsPending = createAction(constants.LOAD_MORE_CAMPAIGNS_PENDING)
export const loadMoreCampaignsCancelled = createAction(constants.LOAD_MORE_CAMPAIGNS_CANCELLED)
export const loadMoreCampaignsFailed = createAction(constants.LOAD_MORE_CAMPAIGNS_FAILED)
export const loadMoreCampaignsSuccess = createAction(constants.LOAD_MORE_CAMPAIGNS_SUCCESS)

export const setDraft = createAction(constants.SET_DRAFT)
export const resetDraft = createAction(constants.RESET_DRAFT)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/campaigns/actions.js